document.addEventListener("DOMContentLoaded", function() {
  const cartCountEl = document.getElementById("cart-count");

  // Function to update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cartCountEl.textContent = cart.item_count;
      });
  }

  // Initial count
  updateCartCount();

  // // Add-to-cart forms
  // document.addEventListener('submit', function(e) {
  //   const form = e.target;
  //   if (form.matches('form[action^="/cart/add"]')) {
  //     e.preventDefault();
  //     const formData = new FormData(form);
  //     fetch('/cart/add.js', { method: 'POST', body: formData })
  //       .then(response => response.json())
  //       .then(() => updateCartCount())
  //       .catch(err => console.error(err));
  //   }
  // });

  // Quantity changes (works for dynamically added inputs)
  document.addEventListener('change', function(e) {
    const input = e.target;
    if (input.matches('input[name="updates[]"]')) {
      const cartForm = document.querySelector('form[action="/cart"]');
      if (!cartForm) return;
      const formData = new FormData(cartForm);
      fetch('/cart/update.js', { method: 'POST', body: formData })
        .then(response => response.json())
        .then(() => updateCartCount())
        .catch(err => console.error(err));
    }
  });
});
